module.exports = "/fonts/vendor/element-ui/lib/theme-chalk/element-icons.woff?535877f50039c0cb49a6196a5b7517cd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = MtQs
// module chunks = 25 26 28 29 30 31 32 33 34 35 36 37 38 39 40